module.exports = "/img/_/_/_/assets/images/icon//gold.png?b0b4c44da9507bd73c9895948f8fcfc6";